import { useContext } from 'react';
import { LocalizationContext } from '../contexts/LocalizationContext';
import { TRANSLATIONS } from '../constants';

export const useLocalization = () => {
  const { language, culture, currency, nationality, setLanguage } = useContext(LocalizationContext);

  const t = (key: string): string => {
    return TRANSLATIONS[language]?.[key] || TRANSLATIONS['en']?.[key] || key;
  };

  return { t, language, culture, currency, nationality, setLanguage };
};